<span #textElement [tp]="$tooltip()" tpVariation="light" [tpOnlyTextOverflow]="true">
    <ng-content></ng-content>
</span>
